import { AiManagementUpdate, AiManagementUpdateComment } from 'services/ai_management_updates';
import Api from '../api';

export interface ListUpdatesParams {
  kind?: string;
  card_id?: number;
  source?: 'manual';
  read?: boolean;
  page?: number;
  per_page?: number;
}

export const listUpdates = (params: ListUpdatesParams = {}) =>
  Api.get('/gestao_ia/atualizacoes', { params });

export const getUnreadUpdatesCount = () => Api.get('/gestao_ia/atualizacoes/nao_lidas');

export const markUpdatesRead = (updateIds: number[]) =>
  Api.patch('/gestao_ia/atualizacoes/marcar_lidas', { update_ids: updateIds });

export const markUpdatesUnread = (updateIds: number[]) =>
  Api.patch('/gestao_ia/atualizacoes/marcar_nao_lidas', { update_ids: updateIds });

export const dismissUpdates = (updateIds: number[]) =>
  Api.patch('/gestao_ia/atualizacoes/excluir', { update_ids: updateIds });

export const markAllUpdatesRead = () => Api.patch('/gestao_ia/atualizacoes/marcar_todas_lidas');

export interface CreateUpdateInput {
  cardId: number;
  title: string;
  description: string;
  publishedOn: string;
  files: File[];
  notes: string[];
}

export const createUpdate = (input: CreateUpdateInput) => {
  const formData = new FormData();
  formData.append('card_id', String(input.cardId));
  formData.append('title', input.title);
  formData.append('description', input.description);
  if (input.publishedOn) formData.append('published_on', input.publishedOn);
  input.files.forEach((file) => formData.append('files[]', file, file.name));
  input.notes.forEach((note) => formData.append('notes[]', note));
  return Api.post<{ update: AiManagementUpdate }>('/gestao_ia/atualizacoes', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const createUpdateNote = (updateId: number, text: string) =>
  Api.post<{ comment: AiManagementUpdateComment }>(
    `/gestao_ia/atualizacoes/${updateId}/anotacoes`,
    {
      text,
    },
  );
